"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/subproject/archive");
//#endregion
//#region INITIAL STATE
exports.initialState = {
    status: 'STANDBY',
    removePermissions: true,
    categories: {}
};
//#endregion
//#region LENS
const statusLens = monocle.Lens.fromProp('status');
const removePermissionsLens = monocle.Lens.fromProp('removePermissions');
const categoriesLens = monocle.Lens.fromProp('categories');
//#endregion
//#region REDUCER
const methods = {};
exports.methods = methods;
methods[ActionTypes.ARCHIVE_REQUEST] = (state, action) => statusLens.set('FETCHING')(state);
methods[ActionTypes.ARCHIVE_SUCCESS] = (state, action) => statusLens.set('FETCHED')(state);
methods[ActionTypes.ARCHIVE_FAILED] = (state, action) => statusLens.set('FAILED')(state);
methods[ActionTypes.SET_PERMISSION_SELECTION] = (state, action) => removePermissionsLens.set(action.payload)(state);
methods[ActionTypes.TOGGLE_CATEGORY] = (state, action) => categoriesLens.modify((x) => {
    const clone = Object.assign({}, x);
    const g = action.payload;
    if (clone[g.id] === undefined) {
        clone[g.id] = g;
    }
    else {
        delete clone[g.id];
    }
    return clone;
})(state);
methods[ActionTypes.CLEAR] = () => (Object.assign({}, exports.initialState));
//#endregion
//# sourceMappingURL=archive.js.map